import { z } from 'zod';

export const add = async (entityType: EntityType): Promise<boolean> => {
    const res = await fetch(`/EntityType`, {
        method: 'POST',
        body: JSON.stringify(entityType),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return res.ok;
};

export const all = async (params: object): Promise<EntityType[]> => {
    let queryString = '';
    if (params) {
        const paramsAsString = JSON.stringify(params)
            .replace(/:/g, '=')
            .replace(/,/g, '&')
            .replace(/[{}"]/g, '');

        const searchParams = new URLSearchParams(paramsAsString);
        queryString = `?${searchParams.toString()}`;
    }

    const response = await fetch(`/EntityType${queryString}`);

    return await response.json();
};

export const update = async (entityType: EntityType): Promise<boolean> => {
    const res = await fetch(`/EntityType`, {
        method: 'PATCH',
        body: JSON.stringify(entityType),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return res.ok;
};
export const EntityTypeSchema = z.object({
    id: z.number().nullable(),
    name: z.string().nonempty({ message: 'An entity type name is required.' }),
    slug: z.string().nullable(),
    deletedOn: z.date().nullable(),
});

export type EntityType = z.infer<typeof EntityTypeSchema>;